<template>
  <div class="faqList">
      <FaqDrawer class="shadow" v-for="faqItem in faqArray" :faqItem="faqItem" :openDrawerOverride="chosenFaqId" :key="faqItem.id" @setChosenFaqId="setChosenFaqId"/>
  </div>
</template>

<script>
import FaqDrawer from '@/components/helpTopics/FaqDrawer.vue';

export default {
    name: 'FaqList',
    props: {
        faqArray: {
            type: Array,
            required: true,
        },
        questionIdInView: {
            required: false,
        },
    },
    components: {
        FaqDrawer,
    },
    data () {
        return {
            chosenFaqId: null,
        };
    },
    methods: {
        setChosenFaqId (faqId = null) {
            this.chosenFaqId = faqId;
        },
    },
    watch: {
        questionIdInView: {
            handler (newId) {
                this.chosenFaqId = newId;
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
